import { render, staticRenderFns } from "./ai-history.vue?vue&type=template&id=4d622e8c&"
import script from "./ai-history.vue?vue&type=script&lang=ts&"
export * from "./ai-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports